import { Typography } from "@mui/material";
import Card from "../Card";
import { SupportContentStyled } from "./styled";


export default function SupportCard({ color, icon, title, description, actionComponent }: SupportCardProps) {
  return (
    <Card headerContent={icon} color={color}>
      <SupportContentStyled>
        <Typography variant="h3Medium" color="neutral20.main">{title}</Typography>
        <Typography variant="body1" color="neutral40.main">{description}</Typography>
        {actionComponent}
      </SupportContentStyled>
    </Card>
  );
}

interface SupportCardProps {
  color: string;
  icon: React.ReactNode;
  title: string;
  description: string;
  actionComponent?: React.ReactNode;
}
